window.addEventListener('DOMContentLoaded', () => {

    document.querySelectorAll('[data-accessibility="contrast"]').forEach( trigger => {

        trigger.addEventListener('click', () => {
            
            document.querySelector('body').classList.toggle('black-and-white');

        });
    });
});